import Container from "@mui/material/Container";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ErrorDialog from "../../components/dialogs/ErrorDialog.js";
import LoadingBackdrop from "../../components/LoadingBackdrop.js";
import { useUser } from "../../components/UserContext.js";
import { postLogin } from "../../lib/apiConfig.js";
import { ROUTES, SESSION_STORAGE_USER_KEY } from "../../lib/constants.js";
import { useFetch } from "../../lib/hooks/useFetch.js";
import Login from "./components/Login.js";

export default function LoginPage({ locales }) {
  const { setUser } = useUser();
  const { runId } = useParams();
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate();

  const { isFetching, fetchData: logIn } = useFetch({
    endpoint: postLogin({ runId }),
    onSuccess: (response) => {
      const user = { ...response.user, runId };

      sessionStorage.setItem(SESSION_STORAGE_USER_KEY, JSON.stringify(user));
      setUser(user);
      navigate(ROUTES.HOME.replace(":runId", runId), { replace: true });
    },
    onFail: (error) => {
      setErrorMessage(error.message);
      setShowError(true);
    },
  });

  return isFetching ? (
    <LoadingBackdrop />
  ) : (
    <Container disableGutters>
      <Login
        locales={locales}
        onChangeUsername={({ target }) => setUsername(target.value)}
        onChangePassword={({ target }) => setPassword(target.value)}
        handleSubmit={() =>
          username && password && logIn({ username, password })
        }
      />
      <ErrorDialog
        locales={locales}
        message={errorMessage}
        onClose={() => {
          setShowError(false);
          setErrorMessage(null);
        }}
        show={showError}
      />
    </Container>
  );
}
